export default "__VITE_ASSET__Cd_DpWRI__"